import Question from "@/models/question";
import HttpClient from "./httpClient";

export default class StorageService {
  public setData(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  public getData(key:string) {
    const data = localStorage.getItem(key);
    if (data == null || data == undefined) {
      this.setData(key, [])
      return []
    }
    return JSON.parse(data)
  }

  public removeData(key: string) {
    localStorage.removeItem(key);
  }

  public setCorrectData(id: number) {
    const data: History[] = this.getData("incorrect")
    const index = data.findIndex(d => {
      return d.i == id
    })
    if (index >= 0) {
      data.splice(index, 1)
    }
    this.setData("incorrect", data)
  }

  public setIncorrectData(id: number) {
    const data: History[] = this.getData("incorrect")
    const index = data.findIndex(d => {
      return d.i == id
    })
    const history = new History()
    history.i = id
    history.d = Date.now()
    if (index >= 0) {
      data.splice(index, 1)
    }
    data.push(history)
    this.setData("incorrect", data)
  }

  public getIncorrectData(dao: HttpClient) {
    const data = this.getData("incorrect")
    const grade = 3
    const ret: HistoryQuestion[] = []
    data.reverse().forEach((d: History) => {
      const hq = new HistoryQuestion()
      hq.question = dao.getQuestionFromId(grade, d.i)
      if (hq.question == null) return
      hq.date = this.formatDate(new Date(d.d), "yyyy/MM/dd")
      ret.push(hq)
    })
    return ret
  }

  private formatDate (date: Date, format: string) {
    format = format.replace(/yyyy/g, String(date.getFullYear()));
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
  }

  public isBookmark(id: number) {
    const data: History[] = this.getData("bookmark")
    const index = data.findIndex(d => {
      return d.i == id
    })
    return index >= 0
  }

  public setBookmarkData(id: number) {
    const data: History[] = this.getData("bookmark")
    const index = data.findIndex(d => {
      return d.i == id
    })
    const history = new History()
    history.i = id
    history.d = Date.now()
    if (index >= 0) {
      data.splice(index, 1)
    } else {
      data.push(history)
    }
    this.setData("bookmark", data)
  }

  public getBookmarkData(dao: HttpClient) {
    const data = this.getData("bookmark")
    const grade = 3
    const ret: HistoryQuestion[] = []
    data.reverse().forEach((d: History) => {
      const hq = new HistoryQuestion()
      hq.question = dao.getQuestionFromId(grade, d.i)
      if (hq.question == null) return
      hq.date = this.formatDate(new Date(d.d), "yyyy/MM/dd")
      ret.push(hq)
    })
    return ret
  }
}

export class History {
  public i: number = 0
  public d: number = 0
}

export class HistoryQuestion {
  public question: Question|null = null
  public date: string = ""
}